export enum BudgetFieldType {
    TEXT = 'TEXT',
    NUMBER = 'NUMBER',
    SELECT = 'SELECT',
    DATE = 'DATE'
}
